import React, { useState, useEffect } from "react";
import axios from "axios";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Button,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from "@mui/material";

const TableForm = ({
  open,
  handleClose,
  fetchData,
  selectedTable,
  handleSuccess,
  handleError,
}) => {
  const API_BASE_URL = process.env.REACT_APP_BASE_URL;

  const [tableName, setTableName] = useState("");
  const [remarks, setRemarks] = useState("");
  const [status, setStatus] = useState("1"); // Default: Active
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (selectedTable) {
      setTableName(selectedTable.table_code);
      setRemarks(selectedTable.remarks || "");
      setStatus(selectedTable.status || "1");
    }
  }, [selectedTable]);

  const handleSubmit = async (event) => {
    event.preventDefault();
    setLoading(true);

    if (!tableName.trim()) {
      handleError("Table name is required.");
      setLoading(false);
      return;
    }

    const tableData = {
      table_code: tableName,
      remarks: remarks,
      status: status,
    };

    try {
      let response;
      if (selectedTable) {
        response = await axios.post(
          `${API_BASE_URL}/Tables/form/${selectedTable.id}`,
          tableData
        );
        handleSuccess("update"); // Call success for update
      } else {
        response = await axios.post(`${API_BASE_URL}/Tables/form`, tableData);
        handleSuccess("add"); // Call success for add
      }

      if (response.status === 200) {
        fetchData();
        handleClose();
      } else {
        handleError(response.data.message || "Failed to save table.");
      }
    } catch (err) {
      handleError("An error occurred while saving the table.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={open} onClose={handleClose}>
      <DialogTitle>
        {selectedTable ? "Edit Table" : "Add Table"}{" "}
        <Button
          onClick={handleClose}
          color="secondary"
          style={{
            position: "absolute",
            top: 10,
            right: 10,
            padding: "0 10px",
          }}
        >
          Close
        </Button>
      </DialogTitle>
      <DialogContent>
        <form onSubmit={handleSubmit}>
          <TextField
            label="Table Name"
            variant="outlined"
            fullWidth
            required
            value={tableName}
            onChange={(e) => setTableName(e.target.value)}
            disabled={loading}
            margin="normal"
          />
          <TextField
            label="Remarks"
            variant="outlined"
            fullWidth
            value={remarks}
            onChange={(e) => setRemarks(e.target.value)}
            disabled={loading}
            margin="normal"
          />
          <FormControl fullWidth margin="normal" disabled={loading}>
            <InputLabel>Status</InputLabel>
            <Select
              value={status}
              onChange={(e) => setStatus(e.target.value)}
              label="Status"
            >
              <MenuItem value="1">Active</MenuItem>
              <MenuItem value="0">Inactive</MenuItem>
            </Select>
          </FormControl>
        </form>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleSubmit} color="primary">
          {loading ? "Saving..." : selectedTable ? "Update Table" : "Add Table"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default TableForm;
